export const getHumanReadableSize = (bytes: number | null): string => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

  if (bytes === 0 || bytes == null) {
    return 'n/a'
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024))

  if (i === 0) {
    return `${bytes} ${sizes[i]}`
  }

  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
}
